import { createFileRoute, redirect } from "@tanstack/react-router";

import { ForgotPasswordRouteComponent } from "./-forgot-password-component";

export const Route = createFileRoute("/auth/forgot-password")({
  component: ForgotPasswordRouteComponent,
  beforeLoad: async ({ context }) => {
    if (context.flags.disableEmailAuth) throw redirect({ to: "/auth/login", replace: true });
  },
});
